/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as RemindersRouteImport } from './routes/reminders'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as IndexRouteImport } from './routes/index'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as FoldersIdRouteImport } from './routes/folders.$id'

const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersRoute = RemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const FoldersIdRoute = FoldersIdRouteImport.update({
  id: '/folders/$id',
  path: '/folders/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/trash': typeof TrashRoute
  '/folders/$id': typeof FoldersIdRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/trash': typeof TrashRoute
  '/folders/$id': typeof FoldersIdRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/reminders': typeof RemindersRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/trash': typeof TrashRoute
  '/folders/$id': typeof FoldersIdRoute
  '/s/$token': typeof STokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/reminders'
    | '/search'
    | '/settings'
    | '/trash'
    | '/folders/$id'
    | '/s/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archive'
    | '/reminders'
    | '/search'
    | '/settings'
    | '/trash'
    | '/folders/$id'
    | '/s/$token'
  id:
    | '__root__'
    | '/'
    | '/archive'
    | '/reminders'
    | '/search'
    | '/settings'
    | '/trash'
    | '/folders/$id'
    | '/s/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchiveRoute: typeof ArchiveRoute
  RemindersRoute: typeof RemindersRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  TrashRoute: typeof TrashRoute
  FoldersIdRoute: typeof FoldersIdRoute
  STokenRoute: typeof STokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders': {
      id: '/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof RemindersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folders/$id': {
      id: '/folders/$id'
      path: '/folders/$id'
      fullPath: '/folders/$id'
      preLoaderRoute: typeof FoldersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchiveRoute: ArchiveRoute,
  RemindersRoute: RemindersRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  TrashRoute: TrashRoute,
  FoldersIdRoute: FoldersIdRoute,
  STokenRoute: STokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
